import logo from './logo.svg';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './Components/Header/Header';
import BinManager from './Pages/BinManager';
import Collectors from './Pages/CollectorsManager';
import AddRoute from './Pages/AddRoute';
import BinDetails from './Pages/BinDetails';
import RouteDetails from './Pages/RouteDetails';
import CollectorsManager from './Pages/CollectorsManager';
import Login from './Pages/Login';
import Register from './Pages/Register';
import AddNewBin from './Pages/AddNewBin';
import AddNewCollector from './Pages/AddNewCollector';
import { useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import auth from './firebase';



function App() {
  const [isLoading, setIsLoading] = useState(true)

  const [user, setUser] = useState({})

  onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser)
    setIsLoading(false);
  })

  

 
  return (
    <BrowserRouter className="App">
      
    <Routes>
      <Route path="/" element={ user?.email ? <BinManager /> : <Login isLoading={isLoading} />} />
      <Route path="/collectors" element={user?.email ? <CollectorsManager /> : <Login isLoading={isLoading} /> } />
      <Route path="/addroute" element={user?.email ? <AddRoute /> : <Login isLoading={isLoading} />} />
      <Route path="/bindetails" element={user?.email ? <BinDetails /> : <Login isLoading={isLoading} /> } />
      <Route path="/routedetails" element={user?.email ? <RouteDetails /> : <Login isLoading={isLoading} /> } />
      <Route path="/login" element={user?.email ? <Login isLoading={isLoading} /> : <Login isLoading={isLoading} />} />
      <Route path="/register" element={user?.email ? <Register /> : <Login isLoading={isLoading} /> } />
      <Route path="/addNewBin" element={user?.email ? <AddNewBin /> : <Login isLoading={isLoading} />} />
      <Route path="/addcollector" element={user?.email ? <AddNewCollector /> : <Login isLoading={isLoading} />} />

    </Routes>
  </BrowserRouter>
   
  );
}

export default App;
